<template>
  <div class="app-container">
    <div v-if="user" class="main">
      <el-row
        :gutter="20"
        style="padding-top: 20px; margin-left: 0; margin-right: 0"
      >
        <el-col :span="6" :xs="24">
          <user-card :user="user" />
        </el-col>

        <el-col :span="18" :xs="24">
          <el-card>
            <!-- <el-tabs v-model="activeTab">
              <el-tab-pane label="Activity" name="activity">
                <activity />
              </el-tab-pane>
              <el-tab-pane label="Timeline" name="timeline">
                <timeline />
              </el-tab-pane>
              <el-tab-pane label="账号" name="account">
                <account :user="user" />
              </el-tab-pane>
            </el-tabs> -->

            <span>
              {{
                $route.query?.tab === "course"
                  ? "我的课程"
                  : $route.query?.tab === "record"
                  ? "我的课程"
                  : "个人中心"
              }}
            </span>
            <el-divider></el-divider>
            <account v-show="$route.query?.tab === undefined" :user="user" />
            <course v-show="$route.query?.tab === 'course'" :user="user" />
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserCard from "./components/UserCard";
// import Activity from './components/Activity'
// import Timeline from './components/Timeline'
import Account from "./components/Account";
import Course from "./components/Course";
import { usersService } from "@/api/users";

export default {
  name: "Profile",
  components: {
    UserCard,
    // Activity,
    // Timeline,
    Account,
    Course
  },
  data() {
    return {
      user: {},
      activeTab: "account",
    };
  },
  computed: {
    ...mapGetters("user", ["name", "avatar", "roles"]),
  },
  created() {
    this.getCurrentUser();

    //const tab = this.$route.query && this.$route.query.tab;
    //console.log(tab);
  },
  methods: {
    getCurrentUser() {
      usersService.getCurrentUser().then((res) => {
        this.user = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto 100px;
  box-sizing: border-box;
  /* padding: 0 10px; */
  min-height: calc(100vh - 320px - 530px - 140px);
}

.el-divider--horizontal {
  margin: 15px 0;
}
</style>
